import * as React from "react"

const Button = ({ dataGoal, href, classname, text, idTrack }) => (
  <a id={idTrack} data-goal={dataGoal} href={href} className={classname}>
    {text}
  </a>
)

export default Button
